import useCopyToClipboard from 'hooks/useCopyToClipboard';

import { CopyIconButton, VariationItem, VariationText } from '../styles/briefPanel.styles';

type CopyVariationItemProps = {
  text: string;
  index: number;
};

const CopyVariationItem = ({ text, index }: CopyVariationItemProps) => {
  const copyToClipboard = useCopyToClipboard();

  return (
    <VariationItem>
      <VariationText>
        {index + 1}. {text}
      </VariationText>
      <CopyIconButton
        onClick={() => copyToClipboard(text)}
        aria-label={`Copy variation ${index + 1}`}
        title="Copy to clipboard"
      >
        &#128203;
      </CopyIconButton>
    </VariationItem>
  );
};

export default CopyVariationItem;
